import React from 'react';
import { Tree, TreeNode } from '@appkit4/react-components/tree';
import './FolderStructure.scss';

export const enum FolderIcon {
    RootFolderIcon = 'icon-folder-closed-outline',
    SubFolder = 'icon-tree-view-outline',
}

interface FolderStructureProps {
    searchText?: string;
    folders: TreeNode[];
    onFolderClick: (node: TreeNode) => void;
}

const FolderStructure = (props: FolderStructureProps) => {
    const foldersKey = JSON.stringify(props.folders);

    const onClickEvent = (item: TreeNode) => {
        props.onFolderClick(item);
    };

    if (props.folders && props.folders.length > 0) {
        return (
            <div className="tree-demo-wrapper">
                <Tree
                    className="folder-structure-tree"
                    data={props.folders}
                    onClick={onClickEvent}
                    key={foldersKey}
                />
            </div>
        );
    } else {
        return <div className="no-folders">No subfolders</div>;
    }
};

export default React.memo(FolderStructure);
